var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "visitor-task-list-view" } }, [
    _vm.showCreateButton
      ? _c(
          "div",
          { staticClass: "create-task-header" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "", classNames: "create-task-button" },
                on: { click: _vm.createTask },
              },
              [
                _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("task.createTask")) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoading && _vm.tasks.length === 0
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("a-spin", { attrs: { size: "large" } }, [
              _c(
                "span",
                {
                  staticClass: "loading-text",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v(_vm._s(_vm.$t("auto.loadingTasks")))]
              ),
            ]),
          ],
          1
        )
      : _vm.tasks.length === 0 && !_vm.isLoading
      ? _c("div", { staticClass: "empty-state" }, [
          _c("div", { staticClass: "empty-state-content" }, [
            _c("span", { staticClass: "material-icons empty-icon" }, [
              _vm._v("assignment"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "empty-text" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.visitorId
                      ? "Bu ziyaretçiye atanmış görev bulunmamaktadır"
                      : "Bu kayda atanmış görev bulunmamaktadır"
                  ) +
                  "\n            "
              ),
            ]),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "visitor-task-table" },
          [
            _c("supsis-table", {
              attrs: {
                columns: _vm.columns,
                rows: _vm.tasks,
                "bottom-pagination": true,
                "pagination-cursor": _vm.paginationCursor,
                options: _vm.tableOptions,
                loading: _vm.isLoading,
              },
              on: { "cursor-changed": _vm.handlePaginationChange },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }